import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import opens from './modules/opens'
import filters from './modules/filters'
import events from './modules/events'
import pins from './modules/pins'
import places from './modules/places'
import users from './modules/users'
import chats from './modules/chats'
import photos from './modules/photos'
import offers from './modules/offers'
import map from './modules/map'
import loaders from './modules/loaders'
import themes from './modules/themes'
import adder from './modules/adder'
import images from './modules/images'
import notifications from './modules/notifications'
import profile from './modules/profile'
import settings from './modules/settings'
import query from './modules/query'
import main from './modules/main'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  modules: {
    auth,
    opens,
    filters,
    events,
    pins,
    users,
    chats,
    photos,
    places,
    loaders,
    offers,
    map,
    notifications,
    themes,
    adder,
    images,
    profile,
    main,
    settings,
    query
  }
})
